import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Div } from '../../styles/Styles';

import { AuthButton } from './Auth.styled';

import { SignUp } from './SignUp/SignUp';
import { SignIn } from './SignIn/SignIn';
import Spinner from 'components/Spinner/Spinner';
import { useAppSelector } from 'app/hooks';

enum ActiveTabs {
  SIGNUP = 1,
  SIGNIN = 2,
}

export const Auth = () => {
  const location = useLocation();

  const [activeTab, setActiveTab] = useState<number>(
    location.pathname.includes('signup') ? ActiveTabs.SIGNUP : ActiveTabs.SIGNIN
  );

  const { loading } = useAppSelector((state) => state.authentication);

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}
      <Div $box $width='50%' $widthSM='100%'>
        <Div $flex>
          <AuthButton
            left='22px'
            active={activeTab === ActiveTabs.SIGNUP}
            onClick={() => setActiveTab(ActiveTabs.SIGNUP)}
          >
            Sign Up
          </AuthButton>
          <AuthButton
            right='22px'
            active={activeTab === ActiveTabs.SIGNIN}
            onClick={() => setActiveTab(ActiveTabs.SIGNIN)}
          >
            Log In
          </AuthButton>
        </Div>
        {activeTab === ActiveTabs.SIGNUP ? <SignUp /> : <SignIn />}
      </Div>
    </>
  );
};
